import { SELECTED_CLINIC_KEY_PREFIX } from "@common/lib/accountScopedStorageKeyPrefixes";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function getStoredSelectedClinicAccountId(effectiveUserId: string): string | null {
    try {
        const v = localStorage.getItem(`${SELECTED_CLINIC_KEY_PREFIX}${effectiveUserId}`);
        if (!v || !UUID_RE.test(v)) {
            return null;
        }
        return v;
    } catch {
        return null;
    }
}

export function setStoredSelectedClinicAccountId(effectiveUserId: string, accountId: string): void {
    try {
        localStorage.setItem(`${SELECTED_CLINIC_KEY_PREFIX}${effectiveUserId}`, accountId);
    } catch {
        /* ignore quota / private mode */
    }
}

export function clearStoredSelectedClinicAccountId(effectiveUserId: string): void {
    try {
        localStorage.removeItem(`${SELECTED_CLINIC_KEY_PREFIX}${effectiveUserId}`);
    } catch {
        /* ignore */
    }
}
